import { render, staticRenderFns } from "./ExpressFastOrdersCreate.vue?vue&type=template&id=6ffed00b&scoped=true"
import script from "./ExpressFastOrdersCreate.vue?vue&type=script&lang=js"
export * from "./ExpressFastOrdersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffed00b",
  null
  
)

export default component.exports